module.exports = __webpack_public_path__ + "static/media/EasyWords_ios_3_preview.e803e1d1.jpg";